//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/kbAndLocaleSelectTemplate.html"], function (
  Marionette,
  LocaleSelectTemplate,
) {
  "use strict";

  var LocaleSelectView = {};

  LocaleSelectView.localeSelectView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: LocaleSelectTemplate,
    events: {
      //This will handle changing which KB is selected.  We use JQuery to figure out the ID of the KB
      //whose drop-down entry was selected
      "change #selectKb": function () {
        var kbId = parseInt(this.$el.find("#selectKb option:selected").val(), 10);
        this.trigger("kb:changed", kbId);
      },
      //This will handle changing which locale is selected.  We use JQuery to figure out the ID of the locale
      //whose drop-down entry was selected
      "change #selectLocale": function () {
        var localeId = parseInt(this.$el.find("#selectLocale option:selected").val(), 10);
        this.trigger("locale:changed", localeId);
      },
    },
  });

  return LocaleSelectView;
});
